module.exports = __webpack_public_path__ + "static/zoe-web-arm-5bbf16c0d36fe566db8b6d23ef9ca3eb.jpg";